import { render, staticRenderFns } from "./reporting_log_activity_types.vue?vue&type=template&id=4d13c1da&scoped=true"
import script from "./reporting_log_activity_types.vue?vue&type=script&lang=js"
export * from "./reporting_log_activity_types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13c1da",
  null
  
)

export default component.exports